import React, {FC, useState} from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"

import {walletTracking} from "@irati-tracking/wallet"
import id from "@irati/utils/id"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import tracking from "@irati-tracking/platform"
import Link, {RouterLink} from "@irati/ui/src/Link"
import {User} from "@irati/types"

import DesktopMenu from "./../DesktopMenu"
import UserMenuContext from "../../shared/UserMenuContext"
import UserMenuTitle from "./Title"
import SwitchAccount from "../../../SwitchAccount"
import UserWallet from "../WalletMenu/UserWallet"
import HeaderLink from "../../shared/HeaderLink"

const StyledHeaderLink = styled(HeaderLink)`
  position: relative;
`

interface Props extends InjectIntl {
  id: string,
  user: User
}

const UserMenu: FC<Props> = (props, context) => {
  if (!authentication.isLoggedIn()) return null

  const [isMenuDisplayed, setIsMenuDisplayed] = useState<boolean>(false)

  const handleMenuClicked = (value?: boolean) => {
    setIsMenuDisplayed((current) => value !== undefined ? value : !current)
  }

  const {user, formatMessage} = props
  const {apps, appPath} = context
  const idNamespace = id("user-menu", props)

  return (
    <DesktopMenu
      id={idNamespace}
      tooltip="usermenu"
      onOutsideClick={() => setIsMenuDisplayed(false)}
      onClick={handleMenuClicked}
      content={
        <>
          <UserWallet
            id={idNamespace}
            text="platform.wallet.menu.user.title"
            onClick={() => walletTracking.clickWalletBalance(0, "", "profileDropdown")} />
          <UserMenuContext id={idNamespace} />

          {appPath !== apps.ACCOUNT && (
            <>
              <RouterLink
                plain
                id={id("link-profile", idNamespace)}
                to="/"
                onClick={() => tracking.clickHeaderMyAccount({source: window.location.href})}
                app={apps.ACCOUNT}>
                <FormattedMessage id="platform.userMenu.header.account" />
              </RouterLink>
              <Link plain id={id("link-help", idNamespace)} target="_blank" href={formatMessage({id: "platform.help.header.href"})}>
                <FormattedMessage id="platform.help.header.text" />
              </Link>
            </>
          )}
          <RouterLink plain id={id("link-logout", idNamespace)} to="/welcome/logout" app={apps.PLATFORM}>
            <FormattedMessage id="platform.userMenu.link.logout" />
          </RouterLink>
          <SwitchAccount />
        </>
      }>
      <StyledHeaderLink id={id("menu-toggle", idNamespace)}>
        <UserMenuTitle user={user} isMenuDisplayed={isMenuDisplayed} />
      </StyledHeaderLink>
    </DesktopMenu>
  )

}

UserMenu.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(UserMenu)
